import { Theme, css } from '@emotion/react'

export const grid = (theme: Theme) => css`
  display: grid;
  grid-gap: ${theme.spacing(3)};
  grid-template-columns: repeat(2, 559px);
  margin-top: ${theme.spacing(1)};
`

export const screenshotField = (theme: Theme) => css`
  position: relative;

  align-self: flex-start;

  padding: ${theme.spacing(5.25)};
  border: 1px dashed ${theme.colors.backgroundOne};
  border-radius: 17px;

  background-color: ${theme.colors.backgroundFive};
`

export const deleteIconButton = (theme: Theme) => css`
  position: absolute;
  top: ${theme.spacing(1.5)};
  left: ${theme.spacing(1.5)};

  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 10px;

  background-color: ${theme.colors.white};

  svg {
    path {
      stroke: ${theme.colors.typographyFour};
    }
  }
`

export const dndIcon = (theme: Theme) => css`
  position: absolute;
  top: ${theme.spacing(1)};
  right: ${theme.spacing(1.5)};

  transform: rotate(90deg);

  circle {
    fill: ${theme.colors.typographyFour};
  }
`

export const dropzoneField = css`
  div {
    padding: 0;
    border: none;
  }
`

export const listItem = (theme: Theme) => css`
  padding: ${theme.spacing(1.75)};
  border-radius: 20px;
  border: 1px solid ${theme.backgrounds.backgroundOne};
  background: ${theme.backgrounds.backgroundFour};
  box-shadow: ${theme.boxShadows.small};
  list-style-type: none;

  text-align: center;
`

export const attachedImage = css`
  max-width: 100%;
  border-radius: 10px;
`

export const deleteAttachmentButton = (theme: Theme) => css`
  margin-top: ${theme.spacing(1.25)};
  width: 100%;

  svg {
    width: 22px;
    height: 22px;
  }
`
